import React from 'react';
import { ButtonBase, Typography } from '@mui/material';

// The Desk's symbols / annotations column folds to a thin rail so the chart gets the room.
// Whether it is folded is a device preference (charter invariant 3: like the theme), not account data.

export const SIDEBAR_RAIL = 32;
const KEY = 'dwlf-desk-sidebar-collapsed';

export const readSidebarCollapsed = () => {
  try { return window.localStorage.getItem(KEY) === '1'; } catch { return false; }
};
export const writeSidebarCollapsed = (collapsed) => {
  try { window.localStorage.setItem(KEY, collapsed ? '1' : '0'); } catch { /* storage blocked: session only */ }
};

const tok = (t) => `var(--dwlf-${t})`;
const LABEL = { fontFamily: '"Space Mono", monospace', textTransform: 'uppercase', letterSpacing: '0.14em', fontSize: '0.5625rem' };

const Chevron = ({ open }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"
    style={{ transition: 'transform 240ms cubic-bezier(0.2, 0, 0, 1)', transform: open ? 'rotate(180deg)' : 'none' }}>
    <path d="M9 5 L16 12 L9 19" />
  </svg>
);

export default function SidebarToggle({ collapsed, onToggle }) {
  if (collapsed) {
    // The whole rail is the target: chevron, then the column's name running down it.
    return (
      <ButtonBase onClick={onToggle} aria-label="Show symbols and annotations" aria-expanded={false}
        sx={{
          position: 'absolute', inset: 0, zIndex: 1, flexDirection: 'column', justifyContent: 'flex-start', gap: 1.5, pt: 1.5,
          color: tok('ink-60'), '&:hover, &.Mui-focusVisible': { color: tok('accent'), backgroundColor: tok('accent-04') },
        }}>
        <Chevron open={false} />
        <Typography component="span" sx={{ ...LABEL, color: 'inherit', writingMode: 'vertical-rl' }}>Symbols · Annotations</Typography>
      </ButtonBase>
    );
  }
  return (
    <ButtonBase onClick={onToggle} aria-label="Hide symbols and annotations" aria-expanded
      sx={{
        order: 1, flexShrink: 0, height: 32, px: 1.5, gap: 1, justifyContent: 'flex-start',
        borderTop: `1px solid ${tok('ink-08')}`, color: tok('ink-50'),
        '&:hover, &.Mui-focusVisible': { color: tok('accent') },
      }}>
      <Chevron open />
      <Typography component="span" sx={{ ...LABEL, color: 'inherit' }}>Collapse</Typography>
    </ButtonBase>
  );
}
